import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
    const { user, token, loading } = useAuth();
    const location = useLocation();

    if (loading) return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{ textAlign: 'center', color: 'white' }}>
                <h1>Cargando...</h1>
            </div>
        </div>
    );

    // Si no hay token, redirigir a Landing (punto de entrada)
    if (!token) {
        console.log('🔐 Acceso denegado: No hay token. Redirigiendo a Landing desde:', location.pathname);
        return <Navigate to="/" state={{ from: location, reason: 'not_authenticated' }} replace />;
    }

    // Validar roles si se especifican
    if (roles && user) {
        const userRolesNames = user.roles?.map(r => typeof r === 'string' ? r : r.name) || [];
        const hasRole = roles.some(role => userRolesNames.includes(role) || userRolesNames.includes('SUPER_ADMIN'));

        if (!hasRole) {
            console.log('🔒 Acceso denegado: Rol no autorizado. Usuario:', userRolesNames, 'Requiere:', roles);
            return <Navigate to="/unauthorized" state={{ from: location, reason: 'insufficient_permissions' }} replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
